export interface TimeStamp {
  nanoseconds: number | null;
  seconds: number | null;
}
